export const policeReportLocationPageTitle = 'Police report location';
export const reportLocationDescription =
  'Knowing the report location will help us get a copy of the report. This will help support your claim.';
